import *as utils from '../utils'
import { get } from './majorProjects'
import {applicationName} from "../utils";



//稿件 名称形式 
export const getManuscriptList =(param, callBack) => {
   get("/cm-sites-" + applicationName()+`/originalStory/storyResourceList`, {time: new Date().getTime(),...param}, callBack)
}

//稿件 日期形式
export const getManuscriptTimeList =(param, callBack) => {
   get("/cm-sites-" + applicationName()+`/originalStory/storyDateResourceList`, {time: new Date().getTime(),...param}, callBack)
}

//图片 任务名称
export const getPicTaskList = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/pictureFile/searchTimeContent`, {time: new Date().getTime(),...param}, callBack)

}

//图片 时间
export const getPicTimeList = (param, callBack) => {
   get("/cm-sites-" + applicationName()+`/pictureFile/searchTime`, {time: new Date().getTime(),...param}, callBack)
}

//视频 任务名称
export const getVideoTaskList = (param, callBack) => {
   get("/cm-sites-" + applicationName()+`/videoFile/searchTimeContent`, {time: new Date().getTime(),...param}, callBack)
}

//视频 时间
export const getVideoTimeList = (param, callBack) => {
   get("/cm-sites-" + applicationName()+`/videoFile/searchTime`, {time: new Date().getTime(),...param}, callBack)

}

//附件 任务名称
export const getAttachTaskList = (param, callBack) => {
   get("/cm-sites-" + applicationName()+`/otherFile/searchTimeContent`, {time: new Date().getTime(),...param}, callBack)
}

//附件 时间
export const getAttachTimeList = (param, callBack) => {
   get("/cm-sites-" + applicationName()+`/otherFile/searchTime`, {time: new Date().getTime(),...param}, callBack)

}


